import { createUniqueId, type JSX } from 'solid-js';
import { t, tPlural } from '../../i18n';
import { useDialogTrap } from '../../lib/dialog-trap';

// The ask before a running role turns off (#6766, prototype askHTML, `:2313-2320`): an
// inline `role="alertdialog"` in the Capabilities zone, named "Turn off {name}", saying what
// happens (new jobs stop at once, the running ones finish). It traps focus through the one
// trap (`lib/dialog-trap.ts`), which is why it is on `testing/overlay-shells.ts`: it lands on
// "Keep on", never on the turn-off, Escape means "Keep on", and closing hands focus back to
// the switch that asked. The card outlines red while it waits (`mission-card--alert`).

export function CapabilityAsk(props: {
  readonly name: string;
  /** How many jobs the role holds here: one reads "this job", more "they". */
  readonly jobs: number;
  readonly onYes: () => void;
  readonly onNo: () => void;
}): JSX.Element {
  const textId = createUniqueId();
  let root: HTMLDivElement | undefined;
  let keep: HTMLButtonElement | undefined;
  useDialogTrap(
    () => true,
    () => root,
    () => props.onNo(),
    () => keep,
  );
  return (
    <div
      ref={root}
      class="mission-ctl__confirm mission-sw-ask"
      role="alertdialog"
      aria-modal="true"
      aria-label={t('fleet.card.caps.ask_label', { name: props.name })}
      aria-describedby={textId}
    >
      <span id={textId}>
        {tPlural('fleet.card.caps.ask', props.jobs, { name: props.name, n: props.jobs })}
      </span>
      <span class="mission-ctl__confirm-actions">
        <button type="button" class="mission-ctl__confirm-yes" onClick={() => props.onYes()}>
          {tPlural('fleet.card.caps.ask_yes', props.jobs)}
        </button>
        <button
          ref={keep}
          type="button"
          class="mission-ctl__confirm-no"
          onClick={() => props.onNo()}
        >
          {t('fleet.card.caps.ask_no')}
        </button>
      </span>
    </div>
  );
}
